import { TableCellsIcon } from '@heroicons/react/24/outline';
import React, { memo } from 'react';
import { Handle, Position } from 'reactflow';
import UpdateDataSettingsModal from './UpdateDataSettingsModal';

const type = 'updatedata';
const nodeName = "Update DataTable";
const icon = <TableCellsIcon className="w-6 h-6 text-gray-400" />;

export function MenuItem({ onSelect }) {
  return (
    <button
      onClick={() => onSelect({
        type: type,
        name: nodeName,
        label: nodeName,
        category: 'document',
        selectedTable: null,
        instructions: '',
        selectedUpstreamNodes: []
      })}
      className="flex items-center gap-3 p-4 hover:bg-dark-300 w-full transition-colors rounded-lg"
    >
      <div className="w-10 h-10 rounded-lg bg-gray-500/20 flex items-center justify-center">
        {icon}
      </div>
      <div className="flex-1 text-left">
        <h3 className="font-medium">{nodeName}</h3>
        <p className="text-sm text-gray-400">Update an existing data table with AI</p>
      </div>
    </button>
  );
}

export const Node = memo(({ data }) => {
  return (
    <div className="bg-dark-200 p-4 rounded-lg min-w-[200px] min-h-[200px]">
      {/* Input Handle */}
      <Handle
        type="target"
        position={Position.Left}
        className="!w-5 !h-5 !bg-dark-300 border-2 border-[#8F9298]"
        style={{ 
          left: '-12px',
          zIndex: 1,
          transform: 'translateY(-50%)'
        }}
      />

      {/* Output Handle */}
      <Handle
        type="source"
        position={Position.Right}
        className="!w-5 !h-5 !bg-dark-300 border-2 border-[#8F9298]"
        style={{ 
          right: '-12px',
          zIndex: 1,
          transform: 'translateY(-50%)'
        }}
      />
      
      <div className="flex flex-col items-center space-y-5">
        {/* Icon Section */}
        <div className="mb-2">
          <div className="w-16 h-16 rounded-lg bg-purple-500/20 flex items-center justify-center">
            <TableCellsIcon className="w-8 h-8 text-purple-500" />
          </div>
        </div>

        {/* Content Section */}
        <div className="w-full text-center">
          <div className="font-medium text-lg">{data.label || 'Update Data Table'}</div>
          {data.selectedTable && (
            <div className="text-sm text-gray-400 mt-1">
              {data.selectedTable.name}
            </div>
          )}
          {data.selectedUpstreamNodes?.length > 0 && (
            <div className="text-sm text-gray-400">
              {data.selectedUpstreamNodes.length} Source{data.selectedUpstreamNodes.length !== 1 ? 's' : ''}
            </div>
          )}
        </div>
      </div>
    </div>
  );
});

export const SettingsModal = UpdateDataSettingsModal;

export const ConnectionRules = {
  canConnect: (sourceNode, targetNode) => {
    // Allow connections from agent nodes to this node
    return sourceNode.data?.category === 'agent';
  }
};
